import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { Form, Formik } from "formik";
import {
  Select,
  CommonButton,
  Input as TextInput,
  textFormatter,
} from "../../../index";

function TransactionsHistoryFilter({
  filterData,
  t,
  onReset,
  loading,
  onSubmit,
  subscriptionData,
  onHandleChange,
}) {
  const [disableReset, setDisableReset] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const arrayOfTypeData = [
    {
      id: "package",
      name: "Packages Plans",
    },
    {
      id: "subscription",
      name: "Subscription",
    },
  ];

  let initialValues = {
    orderId: filterData?.orderId || "",
    name: filterData?.name || "",
    planType: filterData?.planType || undefined,
    planName: filterData?.planName || undefined,
  };

  const onHandleReset = (resetForm) => {
    resetForm({});
    setDisableReset(true);
    if (
      filterData?.orderId ||
      filterData.name ||
      filterData?.planType ||
      filterData?.planName
    ) {
      onReset();
    }
  };

  return (
    <Formik
      initialValues={{ ...initialValues }}
      onSubmit={(e) => {
        if (disableSubmit) {
          onSubmit(e);
        }
      }}
      validate={(e) => {
        if (e.orderId || e.name || e.planType || e.planName) {
          setDisableReset(false);
          setDisableSubmit(true);
        } else {
          setDisableReset(true);
          setDisableSubmit(false);
        }
      }}
    >
      {(props) => {
        return (
          <Form>
            <div className="dropdown-body dropdown-body-rg">
              <Row className="row g-3">
                <Col className="col-md-6">
                  <label className="overline-title overline-title-alt">
                    Invoice ID
                  </label>
                  <TextInput
                    className="form-control "
                    type="text"
                    name="orderId"
                    placeholder="Enter invoice ID"
                    setFieldValue={props.handleChange}
                  />
                </Col>
                <Col className="col-md-6">
                  <label className="overline-title overline-title-alt">
                    User Name
                  </label>
                  <TextInput
                    className="form-control "
                    type="text"
                    name="name"
                    placeholder="Enter user name"
                    setFieldValue={props.handleChange}
                  />
                </Col>
                <Col className="col-md-6">
                  <div className="form-group ">
                    <label className="overline-title overline-title-alt">
                      Plan Type
                    </label>
                    <Select
                      size="medium"
                      id="status"
                      extraClassName="form-control"
                      name="planType"
                      disabled={false}
                      variant="standard"
                      placeholder="Select Type"
                      arrayOfData={arrayOfTypeData}
                      callback={(e) => {
                        onHandleChange(e, props);
                        props.setFieldValue("planType", e);
                      }}
                    />
                  </div>
                </Col>
                <Col className="col-md-6">
                  <div className="form-group ">
                    <label className="overline-title overline-title-alt">
                      Plan Name
                    </label>
                    <Select
                      size="medium"
                      id="plan"
                      extraClassName="form-control"
                      name="planName"
                      disabled={false}
                      variant="standard"
                      placeholder="Select plan"
                      setFieldValue={props.handleChange}
                      arrayOfData={subscriptionData}
                    >
                      {subscriptionData?.length > 0 &&
                        subscriptionData?.map((item) => {
                          return (
                            <option
                              key={item?.name}
                              value={item?.name}
                              title={item?.name}
                            >
                              {textFormatter(item?.name)}
                            </option>
                          );
                        })}
                    </Select>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="dropdown-foot between">
              <Link
                to="#"
                type="button"
                className="clickable"
                onClick={(e) => {
                  e.preventDefault();
                  if (!disableReset) {
                    onHandleReset(props.resetForm);
                  }
                }}
              >
                {t("text.common.reset")}
              </Link>

              <CommonButton
                extraClassName="btn btn-sm btn-primary"
                htmlType="submit"
                loading={loading}
                type="submit"
              >
                {t("text.common.filter")}
              </CommonButton>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default withTranslation()(TransactionsHistoryFilter);
